<template>
  <div class="WaterInfoWaterInfoForm intelligentDocuments">
    <el-dialog title="雨水情告知单" :visible.sync="isShow" @open=" changeTime" :close-on-click-modal="false">
      <div v-loading ="loadingSave">
        <div class="title-top">
          <div>雨水情告知单</div>
          <div>{{year}}年第{{num}}号</div>
        </div>
        <div class="queryAndBtn">
          <div>
             <div><el-input v-model="street" :disabled="true" placeholder="乡镇街道"></el-input></div>
          </div>
           <div>
              <div class="time">时间:</div>
              <div style="margin-right:20px">
                <el-date-picker
                  v-model="query.time"
                  placeholder="请选择获取时间"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  :editable="true"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </div>
              <el-button type="primary" @click="getWaterRegimeInfo">提取信息</el-button>
            </div>
        </div>
        <!-- <div>
          <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="tableData.content"></el-input>
        </div> -->
        <div v-show="isGet" class="table-desc">
          <p>
            根据县山洪灾害监测预警平台显示，以下站点超过预警雨量/水位：
          </p>
          </div>
        <div v-loading = loading
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.1)">
          <table v-show="isGet && tableData.rainList.length>0" ref="rainList" v-loading = loading>
            <tr>
              <td>所在乡镇（街道）</td>
              <td>雨量站</td>
              <td>时段</td>
              <td>时间(小时)</td>
              <td>雨量(毫米)</td>
            </tr>
            <tr v-for="(item,index) in tableData.rainList" :key="index">
              <td style="width:150px">{{item.addvnm}}</td>
              <td>{{item.stnm}}</td>
              <td>{{item.time}}</td>
              <td>{{item.hours}}</td>
              <td>{{item.rain}}</td>
            </tr>
          </table>
        </div>
        <div v-loading = loading
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.1)"
        >
          <table v-show="isGet">
            <tr>
              <td>所在乡镇（街道）</td>
              <td>站点名称</td>
              <td>超警戒/汛限时间</td>
              <td>警戒水位(米)</td>
              <td>超警戒水位(米)</td>
            </tr>
            <tr v-for="(item,index) in tableData.waterList" :key="index">
              <td style="width:150px">{{item.stlc}}</td>
              <td>{{item.stnm}}</td>
              <td>{{item.time}}</td>
              <td>{{item.warnWater}}</td>
              <td>{{item.overWater}}</td>
            </tr>
          </table>
        </div>
         <div v-show="isGet" class="table-desc">
          <p>
            请各地加强水库山塘、海塘堤防和小流域山洪灾害风险区巡查监测，严格落实各项防御措施。
          </p>
          </div>
      </div>
      <div slot="footer">
        <el-button type="info" @click="isShow = false">取 消</el-button>
        <el-button type="primary" @click="save">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import reportAnalysisTypes from '@/store/types/reportAnalysis'
export default {
  data () {
    return {
      isShow: false,
      loading: false,
      loadingSave: false,
      query: {
        time: ''
      },
      isGet: false,
      tableData: {
        rainList: [],
        waterList: []
      },
      street: '',
      year: '',
      num: '',
      checkedTimed: [], //  时间选中列表
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() > Date.now()
        },
        cellClassName: (time) => {
          if (this.checkedTimed.includes(this.getLocalTime(time.getTime()))) {
            return 'timeStyleChecked'
          } else {
            return ''
          }
        }
      }

    }
  },
  methods: {
    getLocalTime (ns) {
      let date = new Date(ns)
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      date = year + '-' + month + '-' + day
      return date
    },
    changeTime () {
      this.isGet = false
      this.tableData = { waterList: [], riverList: [] }
    },
    async getListWarnRecordTime () { // 获取已经预警时间
      this.loading = true
      let result = await this.$store.dispatch(reportAnalysisTypes.GET_LIST_WARN_RECORD_TIME)
      this.checkedTimed = result.rows
      this.loading = false
    },
    async save () {
      if (!this.isGet) {
        this.$notify({
          title: '提示',
          message: '请您先选择时间',
          type: 'warning'
        })
        return false
      }
      this.loadingSave = true
      await this.$store.dispatch(
        reportAnalysisTypes.SAVE_RAIN_WATER_NOTICE,
        this.query
      )
      this.loadingSave = false
      this.$notify.success({ title: '成功', message: '保存成功。' })
      this.isShow = false
      this.$emit('getData')
    },
    async getWaterRegimeInfo () {
      if (!this.query.time) {
        this.$notify({
          title: '提示',
          message: '请您先选择时间',
          type: 'warning'
        })
        return false
      }
      this.loading = true
      this.isGet = false
      this.tableData = { waterList: [], riverList: [] }
      let result = await this.$store.dispatch(
        reportAnalysisTypes.GET_RAIN_WATER_NOTICE_TEMPLATE,
        this.query
      )
      if (result.data.waterList.length !== 0 || result.data.rainList.length !== 0) {
        this.tableData = result.data
        this.street = result.data.stlc
        this.year = result.data.nian
        this.num = result.data.hao
        this.isGet = true
      } else {
        this.$notify({
          title: '提示',
          message: '该时间暂无数据',
          type: 'warning'
        })
      }
      this.loading = false
    }
  },
  mounted () {
    // let nowdate = new Date()
    // this.query.Time = this.$moment(nowdate).format('YYYY-MM-DD HH:00:00')
    this.getListWarnRecordTime()
  }
}
</script>
<style lang="less">
  td.available.timeStyleChecked div span{
      font-weight: 800 !important;
      color: red !important;
    }
</style>
<style lang="less" scoped>
.WaterInfoWaterInfoForm {
  table {
    font-size: 16px;
    width: 100%;
    border-collapse: collapse;
    td {
      border: 1px solid #ccc;
      text-align: center;
      vertical-align: middle;
      height: 30px;
    }
  }
  /deep/ .el-dialog__body {
    & > div {
      & > div:nth-of-type(n + 2) {
        margin-top: 10px;
      }
    }
  }
  /deep/ .el-dialog {
   background: #fff !important;
  }
}
.intelligentDocuments{
    .table{
      /deep/ th{
        background: #F5F7FA !important;
      }
    }
    .title-top {
      height: 50px;
      width: 100%;
      position: relative;
      div:nth-child(1) {
         position: absolute;
          top: 10%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 22px;
          font-weight: bold;
      }
      div:nth-child(2) {
         position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
           font-size: 16px;
           padding-top: 20px;
      }
    }
    .queryAndBtn{
      /deep/ .el-input__inner{
        background-color: #fff !important;
        font-size: 14px;
        }
      display: flex;
      justify-content: space-between;
      align-items: center;
      &>div{
        display: flex;
        align-items: center;
      }
      &>div:nth-child(1){
        &>div{
          display: flex;
          align-items: center;
          &>div{
            display: flex;
            align-items: center;
            font-size: 16px;
            color: #666666;
          }
          &>div:nth-child(2){
            margin-left: 10px;
            &>div:nth-of-type(n+2){
              margin-left: 10px;
            }
          }
        }
        &>div:nth-of-type(n+2){
          margin-left: 10px;
        }
      }
      #add{
        margin-right: auto;
      }
      .time {
        padding-right: 10px;
      }
    }
    .table-desc {
      p {
        font-weight: bold;
        font-size: 17px;
      }
    }
    /deep/ .el-dialog__body{
      background-color: #fff;
      min-height: 200px;
      /deep/ .el-input__inner{
        background-color: #fff !important;
        }
    }
    /deep/ .el-dialog__footer{
      background-color: #fff;
      padding-top: 20px;
    }
  }
</style>
<style lang="less" src="@/assets/waterRainNotice.less" scoped></style>
